import React from "react";
import {ReportsState} from "./ReportsState";
import {ReportsProps} from "./ReportsProps";
import { OrderRepository } from "../../core/orders/domain/OrderRepository";
import { ApiOrderRepository } from "../../core/orders/infrastructure/api/ApiOrderRepository";
import { ShopOrderOfIdFinder } from "../../core/orders/application/find/ShopOrderOfIdFinder";
import { ShopOrdersFinder } from "../../core/orders/application/find/ShopOrdersFinder";
import { Shop } from "../../core/shops/domain/Shop";
import { Order } from "../../core/orders/domain/Order";
import { Button, Card, Collapsible, Range } from "@shopify/polaris";
import { LineItem } from "../../core/orders/domain/LineItem";
import { ShopRepository } from "../../core/shops/domain/ShopRepository";
import { ApiShopRepository } from "../../core/shops/infrastructure/api/ApiShopRepository";
import { AllShopFinder } from "../../core/shops/application/find/AllShopFinder";
import { ShopValidChecker } from "../../core/shops/application/valid/ShopValidChecker";
import { ProductRepository } from "../../core/products/domain/ProductRepository";
import { ApiProductRepository } from "../../core/products/infrastructure/api/ApiProductRepository";
import { ProductLister } from "../../core/products/application/list/ProductLister";
import { Product } from "../../core/products/domain/Product";
import { DatePopover } from "../Shared/DatePopover/DatePopover";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
import { ProductCollapsible } from "./containers/ProductCollapsible/ProductCollapsible";
import { ProductOfShopLister } from "../../core/products/application/list/ProductOfShopLister";
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";

export class Reports extends React.Component<ReportsProps, ReportsState>{

    private _balearCost: number = 7.99;
    private _peninsularCost: number = 6.24;

    private _repository: OrderRepository = new ApiOrderRepository();    
    private _finder: ShopOrdersFinder;

    private _shopRepository: ShopRepository = new ApiShopRepository();
    private _allShopFinder: AllShopFinder;
    private _checker: ShopValidChecker;

    private _productRepository: ProductRepository = new ApiProductRepository();
    private _productLister: ProductLister;
    private _productOfShopLister: ProductOfShopLister;

    private _shops: Shop[] = [];
    constructor(props: any){
        super(props);
        this.state = {
            products: [],
            orders: [], 
            shops: [], 
            shopProducts: {}, 
            dateRangeFilter: {
                start: new Date(new Date().setDate(new Date().getDate() - 30)),
                end: new Date()
                
            }
        }
        this._finder         = new ShopOrdersFinder(this._repository);
        this._allShopFinder  = new AllShopFinder(this._shopRepository);
        this._checker        = new ShopValidChecker(this._shopRepository);
        this._productLister  = new ProductLister(this._productRepository);
        this._productOfShopLister = new ProductOfShopLister(this._productRepository);
        this.loadOrders      = this.loadOrders.bind(this);
        this.render          = this.render.bind(this);
    }

    public componentDidMount(){     
        
        this._productLister.invoke().then((products: Product[]) => {
            this.setState({
                products: products
            });
            this._allShopFinder.invoke().then((shops: Shop[]) => {      
                
                shops.forEach((shop: Shop, index: number, array: Shop[]) => {
                    this._productOfShopLister.invoke(shop).then((e: Product[]) => {
                        this.state.shopProducts[shop.name] = e;
                        this.setState({
                            shopProducts: this.state.shopProducts
                        })
                        this._checker.invoke(shop).then((valid: any) => {
                            if(valid == true){
                                this.state.shops.push(shop);
                                this.setState({ shops: this.state.shops });
                                this.loadOrders(shop, false);
                            }
                        });
                    });
                });       
            });
        });
       
    }
    private loadOrders(shop: Shop, sinceId: Order | boolean){
        this._finder.invoke(shop, sinceId).then((value: [Order[], Order | boolean]) => {
            let orders    = value[0];
            let lastOrder = value[1];
            this.setState({ orders: this.state.orders.concat(...orders) });
            if(lastOrder !== false){
                this.loadOrders(shop, lastOrder);
            }
        });
    }

    render(){
        return (
            <>     
                <DatePopover range={this.state.dateRangeFilter} onDateChange={(range: Range) => {    
                    this.setState({
                        dateRangeFilter: range
                    });
                }} opened={false} onOpened={(value: boolean) => {
                }}></DatePopover>
                <div>{this.renderList}</div>
            </>
        );
    }

    get renderList(){
        return (            
            this.state.shops.map((e: Shop) => {                
                return <div style={{margin: "1em"}}>
                    <Card>
                        <div style={{display: "flex", flexDirection: "column", padding: "1em"}}>
                            <div style={{fontSize: "18px", fontWeight: "bold", marginTop: "8px", marginBottom: "8px"}}>{e.name}</div>
                            <div style={{padding: "4px"}}>Total envios baleares ({this.balearicOrders(e).length}): {this.totalBalearicShipCost(e)}</div>
                            <div style={{padding: "4px"}}>Total envios peninsulares ({this.peninsularOrders(e).length}): {this.totalPeninsularShipCost(e)}</div>
                            <div style={{padding: "4px"}}>Total facturación tienda ({this.sendTagOrders(e).length}): {this.totalBillingShop(e)}</div>
                            <div style={{padding: "4px"}}>Total coste productos: {this.totalCostProducts(e)} </div>
                            <hr></hr>
                            <div  style={{padding: "4px"}}>Total: {this.total(e)}</div>
                            <hr></hr>
                            <div style={{padding: "4px"}}>Primer pedido: {this.firstOrder(e).name} </div>
                            <div style={{padding: "4px"}}>Ultimo pedido: {this.lastOrder(e).name} </div>
                        </div>
                        {this.state.shopProducts[e.name].length > 0 ? <ProductCollapsible list={this.state.shopProducts[e.name]}></ProductCollapsible> : <div></div> }
                    </Card>
                </div>
            })                    
        );
    }

    private ordersOfShop(e: Shop){
        return this.filterByDate(this.state.dateRangeFilter, this.state.orders.filter((value: Order) => value.shop == e.name));
    }
    private sendTagOrders(e: Shop){        
        return this.ordersOfShop(e).filter((e: Order) => e.tags.toLowerCase().includes("enviar"));
    }

    private firstOrder(e: Shop){
        let orders = this.sendTagOrders(e);
        return typeof orders[0] == "undefined" ? {
            name: ""
        } : orders[0];
    }
    private lastOrder(e: Shop){
        let orders = this.sendTagOrders(e);
        return typeof orders[orders.length - 1] == "undefined" ? {
            name: ""
        } :  orders[orders.length - 1];
    }

    private peninsularOrders(e: Shop){
        return this.sendTagOrders(e)
        .filter((e: Order) => e.shippingAddress !== null)
        .filter((e: Order) => e.shippingAddress?.zip !== null)
        .filter((e: Order) => !e.shippingAddress?.zip.startsWith("07"))
    }
    private balearicOrders(e: Shop){
        return this.sendTagOrders(e)
        .filter((e: Order) => e.shippingAddress !== null)
        .filter((e: Order) => e.shippingAddress?.zip !== null)
        .filter((e: Order) => e.shippingAddress?.zip.startsWith("07"))
    }
    private sumOrders(orders: Order[]){
        return orders.map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price))
        .reduce((a: number, b: number) => a + b))
        .reduce((a: number, b: number) => a + b , 0)
        .toFixed(2).toString().replace('.' , ',');
    }

    private filterByDate(range: Range, items: Order[]) {
        let start = range.start;
        let end   = range.end;
        let filteredItems = items.filter((e: Order) => {
          if(typeof e === "undefined" || e == null || !e){
            return null;
          }      
          let timestamp = Date.parse(e.createdAt);
          let date = new Date();
          date.setTime(timestamp);
          if (date.getTime() >= start.getTime() && date.getTime() <= end.getTime()) {
            return e;
          }
          return null;
        });
        return filteredItems;
      }


    private totalCostProducts(e: Shop){
        let ids = this.sendTagOrders(e).map((e: Order) => e.lineItems.map((e: LineItem) => {
            return e.productId;
        }).flat()).flat();                
        let orderShopProducts  = ids.map((id: number) => this.state.shopProducts[e.name].filter((e: Product) => e.id === id)).flat();
        let orderExcelProducts = orderShopProducts.map((p1: Product) => this.state.products.filter((p2: Product) => p1.sku == p2.sku)).flat();
        let totalExcelProfit   = orderExcelProducts.map((e: Product) => e.price).reduce((a: number, b: number) => a + b, 0);
        return totalExcelProfit.toFixed(2).toString().replace('.' , ',');
    }


    private totalCostProductsExcel(e: Shop){
        let ids = this.sendTagOrders(e).map((e: Order) => e.lineItems.map((e: LineItem) => {
            return e.productId;
        }).flat()).flat();                
        let orderShopProducts  = ids.map((id: number) => this.state.shopProducts[e.name].filter((e: Product) => e.id === id)).flat();
        let orderExcelProducts = orderShopProducts.map((p1: Product) => this.state.products.filter((p2: Product) => p1.sku == p2.sku)).flat();
        let totalExcelProfit   = orderExcelProducts.map((e: Product) => e.price).reduce((a: number, b: number) => a + b, 0);
        return totalExcelProfit;
    }


    private productOfId(shop: Shop, id: number){
        return this.state.shopProducts[shop.name].filter((value: Product) => value.id == id)[0];
    }

    private productOfSku(sku: any){
        return this.state.products.filter((value: Product) => value.sku == sku);
    }

    private totalPeninsularShipCost(e: Shop){
        return this.peninsularOrders(e)
        .map((e: Order) => this._peninsularCost)
        .reduce((a: number, b: number) => a+b, 0)
        .toFixed(2).toString().replace('.' , ',');
    }
    private totalBalearicShipCost(e: Shop){
        return this.balearicOrders(e)
        .map((e: Order) => this._balearCost)
        .reduce((a: number, b: number) => a+b, 0)
        .toFixed(2).toString().replace('.' , ',');
    }

    private totalBillingShop(e: Shop){
        return this.sendTagOrders(e)
        .map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price))
        .reduce((a: number, b: number) => a + b))
        .reduce((a: number, b: number) => a + b , 0)
        .toFixed(2).toString().replace('.' , ',');
    }    


    private total(e: Shop){
        let shipCosts = this.peninsularOrders(e)
        .map((e: Order) => this._peninsularCost)
        .reduce((a: number, b: number) => a+b, 0) + this.balearicOrders(e)
        .map((e: Order) => this._balearCost)
        .reduce((a: number, b: number) => a+b, 0);
        let billingShop = this.sendTagOrders(e)
        .map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price))
        .reduce((a: number, b: number) => a + b))
        .reduce((a: number, b: number) => a + b , 0);
        let productCosts = this.totalCostProductsExcel(e);        
        return (billingShop - productCosts - shipCosts).toFixed(2).toString().replace('.' , ',');
    }

    private canceled(order: Order){
        return order.isCancelled == true;
    }
    private notCancelled(order: Order){
        return order.isCancelled != true;
    }

    public totalOfShop(e: Shop){  
        return this.ordersOfShop(e).filter((value: Order) => value.isCancelled !== true ).map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price)).reduce((a: number, b: number) => a + b)).reduce((a: number, b: number) => a + b , 0).toFixed(2).toString().replace('.' , ',');
    }
    public totalPeninsular(e: Shop){
        return this.ordersOfShop(e).filter((value: Order) => value.isCancelled !== true ).filter((e: Order) => e.shippingAddress?.zip == null ? false : !e.shippingAddress?.zip.startsWith("07")).map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price)).reduce((a: number, b: number) => a + b)).reduce((a: number, b: number) => a + b , 0).toFixed(2).toString().replace('.' , ',');
    }
    public totalBalear(e: Shop){
        return this.ordersOfShop(e).filter((value: Order) => value.isCancelled !== true ).filter((e: Order) => e.shippingAddress?.zip == null ? false : e.shippingAddress?.zip.startsWith("07")).map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price)).reduce((a: number, b: number) => a + b)).reduce((a: number, b: number) => a + b , 0).toFixed(2).toString().replace('.' , ',');
    }
    public totalWithoutZip(e: Shop){
        return this.ordersOfShop(e).filter((value: Order) => value.isCancelled !== true ).filter((e: Order) => e.shippingAddress?.zip == null).map((e: Order) => e.lineItems.map((e: LineItem) => parseFloat(e.price)).reduce((a: number, b: number) => a + b)).reduce((a: number, b: number) => a + b , 0).toFixed(2).toString().replace('.' , ',');
    }







    



}